import { DynamicEnvironment } from './dinamic-environment';


// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

class Environment extends DynamicEnvironment {

  public production: boolean;
  constructor() {
    super();
    this.production = false;
  }
  
}

export const environment:any = new Environment();


// WEBPACK FOOTER //
// ./src/environments/environment.ts